<template>
  <BaseDialogForm
    v-model="showChangeConfigurationForm"
    title="Change Configuration"
    :nonFieldErrors="formErrors.non_field_errors"
  >
    <template #actions>
      <v-btn
        color="primary"
        depressed
        @click="submitForm()"
        :disabled="!isValid"
      >
        Submit
      </v-btn>
    </template>
    <template #content>
      <v-form
        v-model="isValid"
        ref="changeConfigurationForm"
        :key="formCount"
        @submit.prevent="submitForm"
      >
        <v-row class="ma-0">
          <v-col cols="12">
            <v-alert
              text
              border="left"
              elevation="0"
              dense
              width="100%"
              type="info"
              class="ma-0"
            >
              Note : Any Changes will only impact on future operations. Past
              data remains unchanged!
            </v-alert>
          </v-col>
          <v-col cols="6" v-if="companyDetails.trip_configuration">
            <SwitchField
              v-model="
                companyDetails.trip_configuration
                  .enable_warehouse_variable_processing_time
              "
              name="enable_warehouse_variable_processing_time"
              label="Enable Warehouse Variable Processing Time"
              :error-messages="
                formErrors?.trip_configuration
                  ?.enable_warehouse_variable_processing_time
              "
              @change="
                delete formErrors.enable_warehouse_variable_processing_time
              "
            />
          </v-col>
          <v-col cols="6">
            <InputField
              v-if="
                companyDetails.trip_configuration &&
                companyDetails.trip_configuration
                  .enable_warehouse_variable_processing_time
              "
              id="warehouse_variable_processing_time_per_100_kg"
              v-model="
                companyDetails.trip_configuration
                  .warehouse_variable_processing_time_per_100_kg
              "
              label="Warehouse Variable Processing time / 100 Kg(In Minutes) "
              name="warehouse_variable_processing_time_per_100_kg"
              :rules="[
                (val) =>
                  !val || val >= 0.1 || 'Value should be greater than 0.1',
              ]"
              :required="true"
              :error-messages="
                formErrors?.trip_configuration
                  ?.warehouse_variable_processing_time_per_100_kg
              "
              @input="
                delete formErrors.warehouse_variable_processing_time_per_100_kg
              "
            />
          </v-col>
          <v-col cols="6" v-if="companyDetails.trip_configuration">
            <SwitchField
              v-model="
                companyDetails.trip_configuration
                  .enable_customer_address_variable_processing_time
              "
              name="enable_customer_address_variable_processing_time"
              label="Enable Customer Address Variable Processing Time"
              :error-messages="
                formErrors?.trip_configuration
                  ?.enable_customer_address_variable_processing_time
              "
              @change="
                delete formErrors.enable_customer_address_variable_processing_time
              "
            />
          </v-col>
          <v-col cols="6">
            <InputField
              v-if="
                companyDetails.trip_configuration &&
                companyDetails?.trip_configuration
                  ?.enable_customer_address_variable_processing_time
              "
              id="customer_address_variable_processing_time_per_100_kg"
              v-model="
                companyDetails.trip_configuration
                  .customer_address_variable_processing_time_per_100_kg
              "
              label="Customer Address Variable Processing time / 100 Kg(In Minutes) "
              name="customer_address_variable_processing_time_per_100_kg"
              :rules="[
                (val) =>
                  !val || val >= 0.1 || 'Value should be greater than 0.1',
              ]"
              :required="true"
              :error-messages="
                formErrors?.trip_configuration
                  ?.customer_address_variable_processing_time_per_100_kg
              "
              @input="
                delete formErrors.customer_address_variable_processing_time_per_100_kg
              "
            />
          </v-col>
        </v-row>
      </v-form>
    </template>
  </BaseDialogForm>
</template>

<script>
import { bus } from "@/main.js";
import BaseDialogForm from "@/components/LayoutComponents/BaseDialogForm.vue";

export default {
  components: {
    BaseDialogForm,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      formCount: 0,
      isValid: true,

      formErrors: {},
      companyDetails: {
        trip_configuration: {
          enable_warehouse_variable_processing_time: false,
          enable_customer_address_variable_processing_time: false,
        },
      },
    };
  },
  computed: {
    showChangeConfigurationForm: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  watch: {
    value(val) {
      if (val) {
        this.getCompanyConfiguration();
      }
      if (!val) {
        this.resetForm();
      }
    },
  },
  methods: {
    getCompanyConfiguration() {
      this.$api.profile
        .getCompanyConfiguration()
        .then((res) => {
          this.companyDetails = res.data;
        })
        .catch((err) => {
          console.error(err);
        });
    },
    resetForm() {
      this.changeConfigurationForm = {};
      this.$refs.changeConfigurationForm.resetValidation();
    },
    submitForm() {
      bus.$emit("showLoader", true);
      this.$api.profile
        .updateCompanyConfiguration(this.companyDetails)
        .then(() => {
          this.showChangeConfigurationForm = false;
          bus.$emit("showToastMessage", {
            message: "Company Configuration changed successfully!",
            color: "success",
          });
          bus.$emit("showLoader", false);
        })
        .catch((err) => {
          this.formErrors = err.data;
          bus.$emit("showLoader", false);
          bus.$emit("showToastMessage", {
            message: "Couldn't change Company Configuration!",
            color: "error",
          });
        });
    },
  },
};
</script>

<style></style>
